export const environment = {
  production: false,
  env: 'UAT',
  logLevel: 0,
  isExtranet: true,
};
